import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import MemberBadge from './MemberBadge';
import { LevelVerifyControl, useParticipantLevels } from './LevelVerifyControl';

// Participants of a group training (Trainerplan detail) + jump to management.
export const GroupTrainingParticipants = ({ programId, API, L, canManage, onNavigate }) => {
  const navigate = useNavigate();
  const [prog, setProg] = useState(null);
  useEffect(() => {
    API.get(`/training-programs/${programId}`).then(({ data }) => setProg(data)).catch(() => setProg({ participants: [] }));
  }, [API, programId]);
  const parts = (prog?.participants || []).filter((p) => ['paid', 'pending'].includes(p.payment_status) || !p.payment_status);
  const [levels, setLevels] = useParticipantLevels(API, parts.map(p => p.user_id));
  if (!prog) return <p className="text-sm text-slate-400">…</p>;
  return (
    <div className="space-y-2" data-testid="group-training-participants">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{L('Participants', 'Teilnehmer')} · {parts.length}/{prog.max_participants || 0}</p>
      {parts.length === 0 ? (
        <p className="text-sm text-slate-400 italic">{L('No enrolments yet.', 'Noch keine Anmeldungen.')}</p>
      ) : (
        <ul className="space-y-1">
          {parts.map((pt, i) => (
            <li key={i} className="flex items-center justify-between gap-2 px-3 py-1.5 rounded-md bg-white border border-slate-200 text-sm" data-testid={`gt-participant-${i}`}>
              <span className="font-semibold text-slate-900 truncate flex items-center gap-1">{pt.user_name}<MemberBadge user={{ user_id: pt.user_id, is_member: levels[pt.user_id]?.is_member }} size={13} /></span>
              <span className="flex items-center gap-1.5 flex-shrink-0">
              <LevelVerifyControl userId={pt.user_id} info={levels[pt.user_id]} API={API} L={L}
                onChanged={(v) => setLevels(m => ({ ...m, [pt.user_id]: { ...(m[pt.user_id] || {}), level_verified: v } }))} />
              <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold uppercase ${pt.payment_status === 'paid' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                {pt.payment_status === 'paid' ? L('Paid', 'Bezahlt') : L('Open', 'Offen')}
              </span>
              </span>
            </li>
          ))}
        </ul>
      )}
      {canManage && (
        <Button size="sm" variant="outline" className="w-full" data-testid="gt-manage-participants-btn"
          onClick={() => { onNavigate?.(); navigate(`/admin/training-programs?open=${programId}`); }}>
          {L('Manage participants', 'Teilnehmer verwalten')}
        </Button>
      )}
    </div>
  );
};
